import React, { useState, useEffect } from "react";
import axios from "axios";
import Spinner from "../components/Spinner";
import { IoCloseOutline } from "react-icons/io5";
import { getClinicIdFromToken } from "../../clinic/utils/tokenUtils";
import { serviceFetchSuggestions } from "./api";

const Autocomplete = ({
  name,
  setname,
  value,
  onChange,
  placeholder,
  onSuggestionSelected,
  setIsNewRelatedPatient,
  setPatientDetails,
  setCheckRelatedPatient,
  resetForm,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false); // State to track if a value is selected
  const [isInitialRender, setIsInitialRender] = useState(true);

  const clinic_id = getClinicIdFromToken();

  useEffect(() => {
    if (isInitialRender) {
      setSelected(true);
      setIsInitialRender(false);
      return;
    }

    if (value && value.length < 2) {
      setSuggestions([]);
      setSelected(false);
      return;
    }

    const fetchSuggestions = async () => {
      if (value) {
        // Check if the input contains only digits
        if (/^\d+$/.test(value)) {
          // Input contains only digits
          if (value.length <= 10) {
            setLoading(true);
            const response = await serviceFetchSuggestions(value, clinic_id);
            if (response?.status) {
              const data = response.data;
              if (name === "patient") {
                console.log(data.patients, "fetchSuggestions");
                setSuggestions(data.patients || []);
              } else {
                setSuggestions(
                  data.medicines.map((medicine) => ({ full_name: medicine }))
                );
              }
              setLoading(false);
            }
          }
        } else {
          // Input contains non-digit characters
          setLoading(true);
          const response = await serviceFetchSuggestions(value, clinic_id);
          if (response?.status) {
            const data = response.data;
            if (name === "patient") {
              console.log(data.patients, "fetchSuggestions");
              setSuggestions(data.patients || []);
            } else {
              setSuggestions(
                data.medicines.map((medicine) => ({ full_name: medicine }))
              );
            }
            setLoading(false);
          }
        }
      }
    };

    const delayDebounceFn = setTimeout(() => {
      fetchSuggestions();
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [value, name]);

  const handleClearValue = () => {
    setSuggestions([]);
    setSelected(false);
    onChange({ target: { name, value: "" } });
    if (resetForm) {
      resetForm();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    // Update according to how you want to handle the suggestion selection
    onChange({ target: { name, value: suggestion.phone_number || "" } });
    console.log("suggestion", suggestion);
    onSuggestionSelected(suggestion);
    setSuggestions([]);
    setSelected(true);
  };

  const handleOnChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d+$/.test(inputValue)) {
      // Input contains only digits
      if (inputValue.length <= 10) {
        onChange(e);
        setSelected(false);
      }
    } else {
      // Input contains non-digit characters
      onChange(e);
      setSelected(false);
    }
  };

  const renderSuggestionWithRelated = (suggestion) => (
    <React.Fragment>
      <li
        className="flex justify-between items-center text-gray-900 cursor-pointer select-none relative py-2 pl-3 pr-3 hover:bg-gray-100"
        onClick={() => handleSuggestionClick(suggestion)}
      >
        <span className="font-medium truncate">{suggestion.full_name}</span>
        <span className="text-blue-300 truncate">
          {suggestion.phone_number}
        </span>
      </li>
      {suggestion.related_patients &&
        suggestion.related_patients.length > 0 &&
        suggestion.related_patients.map((related, index) => (
          <li
            key={`related-${index}`}
            onClick={() => handleSuggestionClick(related)}
          >
            {/* You can add an icon or additional element here to signify a related patient if needed */}
          </li>
        ))}
    </React.Fragment>
  );

  return (
    <div className={` relative w-full autocomplete-container `}>
      <input
        type="text"
        name={name}
        value={value}
        onChange={(e) => handleOnChange(e)}
        placeholder={placeholder}
        className="block w-full bg-gray-50 text-gray-700 border border-gray-300 rounded-md py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-blue-500"
        autoComplete="off"
      />
      {selected && value && (
        <button
          onClick={handleClearValue}
          className="inline-flex items-center px-1 py-1 rounded-full absolute right-2 top-1.5  transition ease-in-out duration-150  bg-indigo-400 text-white"
        >
          <IoCloseOutline />
        </button>
      )}
      <span className=" absolute right-0 top-0">{loading && <Spinner />}</span>

      {suggestions.length > 0 && (
        <ul
          className={` absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm
            ${selected ? " hidden" : ""}`}
        >
          {suggestions?.map((suggestion, index) => (
            <React.Fragment key={index}>
              {renderSuggestionWithRelated(suggestion)}
            </React.Fragment>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Autocomplete;
